
export default [
  {
    path: '/jump-wxapp',
    name: 'jump-wxapp',
    component: () => import(/* webpackChunkName: "jump-wxapp" */ '@/views/jump-wxapp/index.vue'),
    meta: {
      title: 'VIPKID 数学思维'
    }
  }
]
